// extracted by mini-css-extract-plugin
export var button = "_cr-0";
export var donut = "_cr-1";
export var donutFill = "_cr-3";
export var donutTrack = "_cr-2";